
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/channels",
      function () {
        return require("private-next-pages/channels/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/channels"])
      });
    }
  